import type { BuildingChatSections } from "../../../types/buildings-sections/chat";

export const chat: BuildingChatSections = {
  title: "Building Chat",
  placeholder: "Ask about this building...",
  error: "Failed to send message",
  errorMessage: "Something went wrong. Please refresh the chat to continue.",
  refreshChat: "Refresh chat",
  helpSubtitle: "How can I help you manage your building?",
};
